const timer = {
  chinaTimer () {
    const image = new Image()
    image.src = 'https://youtube.com/favicon.ico'
    return new Promise(function (resolve, reject) {
      const judgeTimer = setTimeout(function () {
        if (!image.complete || !image.naturalWidth) {
          image.src = ''
          reject(new Error(false))
        }
      }, 2000) // For development 800ms
      image.onload = () => {
        clearTimeout(judgeTimer)
        resolve(true)
      }
    })
  }
}

export default timer
